module.exports = __webpack_public_path__ + "img/flip-vertical.a1897943.svg";